import './help-me-choose-answers.scss';

import { t } from 'i18next';
import { parseAsString, useQueryState } from 'nuqs';

import { Checkbox } from '@sola/ark-core/molecules/checkbox/checkbox.js';

import { SelectionCard } from '../../../molecules/selection-card/selection-card';
import { boyImage } from '../images/boy-help-me-choose';
import { girlImage } from '../images/girl-help-me-choose';

export const genderAnswers = [
  {
    id: 'boy',
    value: 'Male',
    image: boyImage,
  },
  {
    id: 'girl',
    value: 'Female',
    image: girlImage,
  },
];

export const HelpMeChooseGender: React.FC = () => {
  const [gender, setGender] = useQueryState('gender', parseAsString);

  const handleCheckboxChange = (value: string, isChecked: boolean) => {
    if (isChecked) {
      setGender(value);
    }
    if (!isChecked && gender === value) {
      setGender(null);
    }
  };

  return (
    <div className="HelpMeChooseAnswers flex flex-col sm:flex-row gap-comfy-sm justify-center">
      {genderAnswers.map((card) => {
        return (
          <Checkbox
            name={card.id}
            fieldClasses="Checkbox__card"
            label={t(`help-me:genderAnswers.${card.id}`)}
            checked={gender === card.value}
            onChange={(e) =>
              handleCheckboxChange(card.value, e.currentTarget.checked)
            }
            labelContent={
              <SelectionCard
                variant="stacked"
                isChecked={gender === card.value}
                details={{
                  image: {
                    alt: t(`help-me:genderAnswers.${card.id}Alt`),
                    url: card.image,
                  },
                  label: t(`help-me:genderAnswers.${card.id}`),
                  primaryBody: t(`help-me:genderAnswers.${card.id}`),
                  secondaryTitle: t(`help-me:genderAnswers.${card.id}`),
                  secondaryText: t(
                    `help-me:genderAnswers.${card.id}SecondaryText`,
                  ),
                  value: card.value,
                }}
              />
            }
          />
        );
      })}
    </div>
  );
};
